import React from 'react';
import { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box, Grid } from '@mui/material';
import CalenderIcon from '../../../../assets/img/V1/calender-icon.svg';

const CalendarIcon = () => <Box component="img" src={CalenderIcon} alt="Calendar" />;

interface CustomDatePickerProps {
  value: Dayjs | null;
  onChange: (_event: Dayjs | null) => void;
  minDate?: Dayjs;
  maxDate?: Dayjs;
}

export const CustomDatePicker = ({ value, onChange, minDate, maxDate }: CustomDatePickerProps) => (
  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-GB">
    {' '}
    <Grid container>
      {' '}
      <DatePicker
        value={value}
        onChange={onChange}
        slots={{
          openPickerIcon: CalendarIcon,
        }}
        format="DD/MM/YYYY"
        slotProps={{
          textField: {
            size: 'small',
            fullWidth: true,
            InputProps: {
              sx: { borderRadius: '8px' },
            },
          },
        }}
        minDate={minDate}
        maxDate={maxDate}
        disableFuture
      />
    </Grid>
  </LocalizationProvider>
);
